import { render, staticRenderFns } from "./Partial.vue?vue&type=template&id=86971660&"
import script from "./Partial.vue?vue&type=script&lang=js&"
export * from "./Partial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports